/**
 * Paddle Canceled Page Component
 * Handles canceled payment redirects from Paddle
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircleIcon, ArrowLeftIcon } from '@heroicons/react/24/outline';

const CanceledPage = () => {
  const navigate = useNavigate();

  const handleRetryPayment = () => {
    navigate('/dashboard');
  };

  const handleReturnHome = () => {
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <XCircleIcon className="w-8 h-8 text-yellow-600" />
        </div>
        
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Payment Canceled</h2>
        <p className="text-gray-600 mb-6">
          Your payment was canceled. No charges have been made to your account.
        </p>
        
        <div className="bg-yellow-50 rounded-lg p-4 mb-6">
          <p className="text-sm text-yellow-800">
            You can try again anytime or contact support if you need assistance.
          </p>
        </div>
        
        <div className="space-y-3">
          <button
            onClick={handleRetryPayment}
            className="w-full bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center"
          >
            Try Again
            <ArrowLeftIcon className="w-4 h-4 ml-2" />
          </button>
          
          <button
            onClick={handleReturnHome}
            className="w-full bg-gray-600 text-white px-6 py-3 rounded-lg hover:bg-gray-700 transition-colors"
          >
            Return to Dashboard
          </button>
        </div>
        
        <p className="text-xs text-gray-500 mt-4">
          Your subscription remains unchanged.
        </p>
      </div>
    </div>
  );
};

export default CanceledPage;


